<template>
  <div
    class="page"
    ref="page"
    v-loading="loading"
    element-loading-text="加载中..."
    element-loading-background="rgba(0, 0, 0, 0.3)"
  >
    <div class="page-search" ref="search">
      <div class="search-row">
        <el-date-picker
          v-model="searchForm.startTime"
          type="date"
          placeholder="开始日期"
          value-format="yyyy-MM-dd"
          :picker-options="startDatePickerOptions"
        ></el-date-picker>
        <el-date-picker
          v-model="searchForm.endTime"
          type="date"
          placeholder="结束日期"
          value-format="yyyy-MM-dd"
          :picker-options="endDatePickerOptions"
        ></el-date-picker>
        <el-input
          v-model="searchForm.customerCode"
          placeholder="请输入客户编码"
        ></el-input>
        <el-input
          v-model="searchForm.customerName"
          placeholder="请输入客户名称"
        ></el-input>
        <el-input
          v-model="searchForm.subCompanyCode"
          placeholder="请输入分公司编码"
          style="margin-right: 0"
        ></el-input>
      </div>
      <div class="search-row">
        <el-input
          v-model="searchForm.subCompanyName"
          placeholder="请输入分公司名称"
        ></el-input>
        <el-input
          v-model="searchForm.productName"
          placeholder="请输入产品名称"
        ></el-input>
        <el-input
          v-model="searchForm.productCode"
          placeholder="请输入产品编码"
        ></el-input>
        <el-input
          v-model="searchForm.companyName"
          placeholder="请输入公司主体"
        ></el-input>
        <el-select
          v-model="searchForm.saleChannel"
          placeholder="请选择渠道模式"
          style="margin-right: 0"
        >
          <el-option
            v-for="item in channelOptions"
            :key="item.dictCode"
            :label="item.dictValue"
            :value="item.dictCode"
          ></el-option>
        </el-select>
      </div>
      <div class="search-row">
        <el-input
          v-model="searchForm.orderCode"
          placeholder="请输入需货单号"
        ></el-input>
        <el-input
          v-model="searchForm.productLevelName"
          placeholder="请输入产品系列"
        ></el-input>
      </div>
      <div class="select-row" style="justify-content: space-between">
        <div>
          <span style="font-weight: bold; font-size: 14px">动态模块展示选择：</span>
          <el-button type="default" @click="openModuleDialog">选择模块</el-button>
          <span style="font-weight: bold; font-size: 14px; margin-left: 20px">动态二级参数选择：</span>
          <el-button type="default" @click="openParamDialog">选择参数</el-button>
          <span style="font-weight: bold; font-size: 14px; margin-left: 20px">动态三级参数选择：</span>
          <el-button type="default" @click="openThirdLevelDialog">选择参数</el-button>
        </div>
        <div>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
          <el-button @click="handleExport">导出</el-button>
        </div>
      </div>
    </div>
    <div class="page-table">
      <vxe-table
        :key="tableKey"
        border
        show-overflow
        ref="xTable"
        size="mini"
        resizable
        :data="tableData"
        :auto-resize="true"
        :fixed-header="true"
        :height="tableHeight"
        :show-footer="true"
        :footer-method="footerMethod"
      >
        <vxe-column field="yearMonthStr" width="100" title="期间"></vxe-column>
        <vxe-column
          field="invoiceDate"
          width="100"
          title="业务日期"
        ></vxe-column>
        <vxe-column
          field="subCompanyName"
          width="100"
          title="分公司"
        ></vxe-column>
        <vxe-column
          field="customerName"
          width="100"
          title="经销商"
        ></vxe-column>
        <vxe-column
          field="productCode"
          width="100"
          title="产品编码"
        ></vxe-column>
        <vxe-column
          field="productName"
          width="100"
          title="产品名称"
        ></vxe-column>
        <vxe-column field="spec" width="100" title="规格型号"></vxe-column>
        <vxe-column
          field="actualTaxPrice"
          width="120"
          title="实际含税单价(元/盒)"
        ></vxe-column>
        <vxe-column
          field="totalQuantity"
          width="100"
          title="数量(盒)"
        ></vxe-column>
        <vxe-column
          field="totalAmount"
          width="120"
          title="应收金额(含税)"
        ></vxe-column>
        <vxe-column
          field="companyName"
          width="100"
          title="公司主体"
        ></vxe-column>
        <vxe-column field="saleChannelName" width="100" title="渠道模式"></vxe-column>
        <vxe-column field="orderCode" width="100" title="需货单号"></vxe-column>
        <vxe-column
          field="productLevelName"
          width="100"
          title="产品系列"
        ></vxe-column>

        <vxe-colgroup
          v-if="showModule('group1')"
          title="生产投入"
          field="group1"
          header-align="center"
        >
          <vxe-colgroup
            v-if="showParam('dealerInput')"
            title="经销商投入"
            field="group1-1"
            header-align="center"
          >
            <vxe-colgroup
              v-if="showThirdLevel('scanFee')"
              title="扫码费用"
              field="group1-1-1"
              header-align="center"
            >
              <vxe-column
                field="scJxsScanFeeStandard"
                width="100"
                title="标准"
              ></vxe-column>
              <vxe-column
                field="scJxsScanFeeAmount"
                width="100"
                title="金额"
              ></vxe-column>
            </vxe-colgroup>
            <vxe-colgroup
              v-if="showThirdLevel('quarterAchieve')"
              title="季度达成"
              field="group1-1-2"
              header-align="center"
            >
              <vxe-column
                field="scJxsQuarterAchieveStandard"
                width="100"
                title="标准"
              ></vxe-column>
              <vxe-column
                field="scJxsQuarterAchieveAmount"
                width="100"
                title="金额"
              ></vxe-column>
            </vxe-colgroup>
            <vxe-colgroup
              v-if="showThirdLevel('stablePriceSubsidy')"
              title="稳价补贴"
              field="group1-1-3"
              header-align="center"
            >
              <vxe-column
                field="scJxsStablePriceSubsidyStandard"
                width="100"
                title="标准"
              ></vxe-column>
              <vxe-column
                field="scJxsStablePriceSubsidyAmount"
                width="100"
                title="金额"
              ></vxe-column>
            </vxe-colgroup>
          </vxe-colgroup>

          <vxe-colgroup
            v-if="showParam('tobaccoShopInput')"
            title="烟酒店投入"
            field="group1-2"
            header-align="center"
          >
            <vxe-colgroup
              v-if="showThirdLevel('scanFee')"
              title="扫码费用"
              field="group1-2-1"
              header-align="center"
            >
              <vxe-column
                field="scYjdScanFeeStandard"
                width="100"
                title="标准"
              ></vxe-column>
              <vxe-column
                field="scYjdScanFeeAmount"
                width="100"
                title="金额"
              ></vxe-column>
            </vxe-colgroup>
            <vxe-colgroup
              v-if="showThirdLevel('quarterAchieve')"
              title="季度达成"
              field="group1-2-2"
              header-align="center"
            >
              <vxe-column
                field="scYjdQuarterAchieveStandard"
                width="100"
                title="标准"
              ></vxe-column>
              <vxe-column
                field="scYjdQuarterAchieveAmount"
                width="100"
                title="金额"
              ></vxe-column>
            </vxe-colgroup>
            <vxe-colgroup
              v-if="showThirdLevel('reverseSales')"
              title="动销反向"
              field="group1-2-3"
              header-align="center"
            >
              <vxe-column
                field="scYjdReverseSalesStandard"
                width="100"
                title="标准"
              ></vxe-column>
              <vxe-column
                field="scYjdReverseSalesAmount"
                width="100"
                title="金额"
              ></vxe-column>
            </vxe-colgroup>
            <vxe-colgroup
              v-if="showThirdLevel('stablePriceSubsidy')"
              title="稳价补贴"
              field="group1-2-4"
              header-align="center"
            >
              <vxe-column
                field="scYjdStablePriceSubsidyStandard"
                width="100"
                title="标准"
              ></vxe-column>
              <vxe-column
                field="scYjdStablePriceSubsidyAmount"
                width="100"
                title="金额"
              ></vxe-column>
            </vxe-colgroup>
          </vxe-colgroup>

          <vxe-colgroup
            v-if="showParam('marketOperationInput')"
            title="市场运营投入"
            field="group1-3"
            header-align="center"
          >
            <vxe-colgroup
              v-if="showThirdLevel('strategyInput')"
              title="战略投入"
              field="group1-3-1"
              header-align="center"
            >
              <vxe-column
                field="scScyyStrategyInputStandard"
                width="100"
                title="标准"
              ></vxe-column>
              <vxe-column
                field="scScyyStrategyInputAmount"
                width="100"
                title="金额"
              ></vxe-column>
            </vxe-colgroup>
            <vxe-colgroup
              v-if="showThirdLevel('companyOverallInput')"
              title="公司统筹投入"
              field="group1-3-2"
              header-align="center"
            >
              <vxe-column
                field="scScyyCompanyOverallInputStandard"
                width="100"
                title="标准"
              ></vxe-column>
              <vxe-column
                field="scScyyCompanyOverallInputAmount"
                width="100"
                title="金额"
              ></vxe-column>
            </vxe-colgroup>
            <vxe-colgroup
              v-if="showThirdLevel('marketBaseOverall')"
              title="市场基础投入-统筹"
              field="group1-3-3"
              header-align="center"
            >
              <vxe-column
                field="scScyyMarketBaseOverallStandard"
                width="100"
                title="标准"
              ></vxe-column>
              <vxe-column
                field="scScyyMarketBaseOverallAmount"
                width="100"
                title="金额"
              ></vxe-column>
            </vxe-colgroup>
            <vxe-colgroup
              v-if="showThirdLevel('marketBaseCustomer')"
              title="市场基础投入-经销商"
              field="group1-3-4"
              header-align="center"
            >
              <vxe-column
                field="scScyyMarketBaseCustomerStandard"
                width="100"
                title="标准"
              ></vxe-column>
              <vxe-column
                field="scScyyMarketBaseCustomerAmount"
                width="100"
                title="金额"
              ></vxe-column>
            </vxe-colgroup>
            <vxe-colgroup
              v-if="showThirdLevel('specialInput')"
              title="专项投入"
              field="group1-3-5"
              header-align="center"
            >
              <vxe-column
                field="scScyySpecialInputStandard"
                width="100"
                title="标准"
              ></vxe-column>
              <vxe-column
                field="scScyySpecialInputAmount"
                width="100"
                title="金额"
              ></vxe-column>
            </vxe-colgroup>
          </vxe-colgroup>

          <vxe-colgroup
            v-if="showParam('salesCommission')"
            title="销售人员提成"
            field="group1-4"
            header-align="center"
          >
            <vxe-column
              field="scSalesCommissionStandard"
              width="100"
              title="标准"
            ></vxe-column>
            <vxe-column
              field="scSalesCommissionAmount"
              width="100"
              title="金额"
            ></vxe-column>
          </vxe-colgroup>

          <vxe-colgroup
            v-if="showParam('promoterRights')"
            title="推广大使权益"
            field="group1-5"
            header-align="center"
          >
            <vxe-column
              field="scAmbassadorRightsStandard"
              width="100"
              title="标准"
            ></vxe-column>
            <vxe-column
              field="scAmbassadorRightsAmount"
              width="100"
              title="金额"
            ></vxe-column>
          </vxe-colgroup>

          <vxe-colgroup
            v-if="showParam('fengxiangHui')"
            title="凤香荟"
            field="group1-6"
            header-align="center"
          >
            <vxe-column
              field="scFxhStandard"
              width="100"
              title="标准"
            ></vxe-column>
            <vxe-column
              field="scFxhAmount"
              width="100"
              title="金额"
            ></vxe-column>
          </vxe-colgroup>

          <vxe-colgroup
            v-if="showParam('consumerReward')"
            title="消费者奖励"
            field="group1-7"
            header-align="center"
          >
            <vxe-column
              field="scConsumerRewardStandard"
              width="100"
              title="标准"
            ></vxe-column>
            <vxe-column
              field="scConsumerRewardAmount"
              width="100"
              title="金额"
            ></vxe-column>
          </vxe-colgroup>

          <vxe-colgroup
            v-if="showParam('channelCost')"
            title="渠道费用"
            field="group1-8"
            header-align="center"
          >
            <vxe-colgroup
              v-if="showThirdLevel('jointBuildFee')"
              title="厂商共建费用"
              field="group1-8-1"
              header-align="center"
            >
              <vxe-column
                field="scQdJointBuildFeeStandard"
                width="100"
                title="标准"
              ></vxe-column>
              <vxe-column
                field="scQdJointBuildFeeAmount"
                width="100"
                title="金额"
              ></vxe-column>
            </vxe-colgroup>
            <vxe-colgroup
              v-if="showThirdLevel('discountFee')"
              title="折让费用"
              field="group1-8-2"
              header-align="center"
            >
              <vxe-column
                field="scQdDiscountFeeStandard"
                width="100"
                title="标准"
              ></vxe-column>
              <vxe-column
                field="scQdDiscountFeeAmount"
                width="100"
                title="金额"
              ></vxe-column>
            </vxe-colgroup>
            <vxe-colgroup
              v-if="showThirdLevel('outboundScanReward')"
              title="出库扫码奖励"
              field="group1-8-3"
              header-align="center"
            >
              <vxe-column
                field="scQdOutboundScanRewardStandard"
                width="100"
                title="标准"
              ></vxe-column>
              <vxe-column
                field="scQdOutboundScanRewardAmount"
                width="100"
                title="金额"
              ></vxe-column>
            </vxe-colgroup>
            <vxe-colgroup
              v-if="showThirdLevel('deposit')"
              title="保证金"
              field="group1-8-4"
              header-align="center"
            >
              <vxe-column
                field="scQdDepositStandard"
                width="100"
                title="标准"
              ></vxe-column>
              <vxe-column
                field="scQdDepositAmount"
                width="100"
                title="金额"
              ></vxe-column>
            </vxe-colgroup>
            <vxe-colgroup
              v-if="showThirdLevel('salesRelatedReward')"
              title="动销关联奖励"
              field="group1-8-5"
              header-align="center"
            >
              <vxe-column
                field="scQdSalesRelatedRewardStandard"
                width="100"
                title="标准"
              ></vxe-column>
              <vxe-column
                field="scQdSalesRelatedRewardAmount"
                width="100"
                title="金额"
              ></vxe-column>
            </vxe-colgroup>
          </vxe-colgroup>

          <vxe-column field="scSubtotal" width="100" title="小计"></vxe-column>
        </vxe-colgroup>

        <vxe-colgroup
          v-if="showModule('group2')"
          title="释放投入"
          field="group2"
          header-align="center"
        >
          <vxe-colgroup
            v-if="showParam('dealerInput')"
            title="经销商投入"
            field="group2-1"
            header-align="center"
          >
            <vxe-column
              v-if="showThirdLevel('scanFee')"
              field="sfJxsScanFee"
              width="100"
              title="扫码费用"
            ></vxe-column>
            <vxe-column
              v-if="showThirdLevel('quarterAchieve')"
              field="sfJxsQuarterAchieveAmount"
              width="100"
              title="季度达成"
            ></vxe-column>
            <vxe-column
              v-if="showThirdLevel('stablePriceSubsidy')"
              field="sfJxsStablePriceSubsidyAmount"
              width="100"
              title="稳价补贴"
            ></vxe-column>
          </vxe-colgroup>

          <vxe-colgroup
            v-if="showParam('tobaccoShopInput')"
            title="烟酒店投入"
            field="group2-2"
            header-align="center"
          >
            <vxe-column
              v-if="showThirdLevel('scanFee')"
              field="sfYjdScanFeeAmount"
              width="100"
              title="扫码费用"
            ></vxe-column>
            <vxe-column
              v-if="showThirdLevel('quarterAchieve')"
              field="sfYjdQuarterAchieveAmount"
              width="100"
              title="季度达成"
            ></vxe-column>
            <vxe-column
              v-if="showThirdLevel('reverseSales')"
              field="sfYjdReverseSalesAmount"
              width="100"
              title="动销反向"
            ></vxe-column>
            <vxe-column
              v-if="showThirdLevel('stablePriceSubsidy')"
              field="sfYjdStablePriceSubsidyAmount"
              width="100"
              title="稳价补贴"
            ></vxe-column>
          </vxe-colgroup>

          <vxe-colgroup
            v-if="showParam('marketOperationInput')"
            title="市场运营投入"
            field="group2-3"
            header-align="center"
          >
            <vxe-column
              v-if="showThirdLevel('strategyInput')"
              field="sfScyyStrategyInputAmount"
              width="100"
              title="战略投入"
            ></vxe-column>
            <vxe-column
              v-if="showThirdLevel('companyOverallInput')"
              field="sfScyyCompanyOverallInputAmount"
              width="100"
              title="公司统筹投入"
            ></vxe-column>
            <vxe-column
              v-if="showThirdLevel('marketBaseOverall')"
              field="sfScyyMarketBaseOverallAmount"
              width="100"
              title="市场基础投入-统筹"
            ></vxe-column>
            <vxe-column
              v-if="showThirdLevel('marketBaseCustomer')"
              field="sfScyyMarketBaseCustomerAmount"
              width="100"
              title="市场基础投入-经销商"
            ></vxe-column>
            <vxe-column
              v-if="showThirdLevel('specialInput')"
              field="sfScyySpecialInputAmount"
              width="100"
              title="专项投入"
            ></vxe-column>
          </vxe-colgroup>

          <vxe-column
            v-if="showParam('salesCommission')"
            field="sfSalesCommission"
            width="100"
            title="销售人员提成"
          ></vxe-column>

          <vxe-column
            v-if="showParam('promoterRights')"
            field="sfAmbassadorRightsAmount"
            width="100"
            title="推广大使权益"
          ></vxe-column>

          <vxe-column
            v-if="showParam('fengxiangHui')"
            field="sfFxhAmount"
            width="100"
            title="凤香荟"
          ></vxe-column>

          <vxe-column
            v-if="showParam('consumerReward')"
            field="sfConsumerRewardAmount"
            width="100"
            title="消费者奖励"
          ></vxe-column>

          <vxe-colgroup
            v-if="showParam('channelCost')"
            title="渠道费用"
            field="group2-4"
            header-align="center"
          >
            <vxe-column
              v-if="showThirdLevel('jointBuildFee')"
              field="sfQdJointBuildFeeAmount"
              width="100"
              title="厂商共建费用"
            ></vxe-column>
            <vxe-column
              v-if="showThirdLevel('discountFee')"
              field="sfQdDiscountFeeAmount"
              width="100"
              title="折让费用"
            ></vxe-column>
            <vxe-column
              v-if="showThirdLevel('outboundScanReward')"
              field="sfQdOutboundScanRewardAmount"
              width="100"
              title="出库扫码奖励"
            ></vxe-column>
            <vxe-column
              v-if="showThirdLevel('deposit')"
              field="sfQdDepositAmount"
              width="100"
              title="保证金"
            ></vxe-column>
            <vxe-column
              v-if="showThirdLevel('salesRelatedReward')"
              field="sfQdSalesRelatedRewardAmount"
              width="100"
              title="动销关联奖励"
            ></vxe-column>
          </vxe-colgroup>

          <vxe-column field="sfSubtotal" width="100" title="小计"></vxe-column>
        </vxe-colgroup>

        <vxe-colgroup
          v-if="showModule('group3')"
          title="已申请投入"
          field="group3"
          header-align="center"
        >
          <vxe-colgroup
            v-if="showParam('dealerInput')"
            title="经销商投入"
            field="group3-1"
            header-align="center"
          >
            <vxe-column
              v-if="showThirdLevel('scanFee')"
              field="ysqJxsScanFee"
              width="100"
              title="扫码费用"
            ></vxe-column>
            <vxe-column
              v-if="showThirdLevel('quarterAchieve')"
              field="ysqJxsQuarterAchieveAmount"
              width="100"
              title="季度达成"
            ></vxe-column>
            <vxe-column
              v-if="showThirdLevel('stablePriceSubsidy')"
              field="ysqJxsStablePriceSubsidyAmount"
              width="100"
              title="稳价补贴"
            ></vxe-column>
          </vxe-colgroup>

          <vxe-colgroup
            v-if="showParam('tobaccoShopInput')"
            title="烟酒店投入"
            field="group3-2"
            header-align="center"
          >
            <vxe-column
              v-if="showThirdLevel('scanFee')"
              field="ysqYjdScanFeeAmount"
              width="100"
              title="扫码费用"
            ></vxe-column>
            <vxe-column
              v-if="showThirdLevel('quarterAchieve')"
              field="ysqYjdQuarterAchieveAmount"
              width="100"
              title="季度达成"
            ></vxe-column>
            <vxe-column
              v-if="showThirdLevel('reverseSales')"
              field="ysqYjdReverseSalesAmount"
              width="100"
              title="动销反向"
            ></vxe-column>
            <vxe-column
              v-if="showThirdLevel('stablePriceSubsidy')"
              field="ysqYjdStablePriceSubsidyAmount"
              width="100"
              title="稳价补贴"
            ></vxe-column>
          </vxe-colgroup>

          <vxe-column
            v-if="showParam('consumerReward')"
            field="ysqConsumerRewardAmount"
            width="100"
            title="消费者奖励"
          ></vxe-column>

          <vxe-colgroup
            v-if="showParam('channelCost')"
            title="渠道费用"
            field="group3-3"
            header-align="center"
          >
            <vxe-column
              v-if="
                showThirdLevel('jointBuildFee') || showThirdLevel('discountFee')
              "
              field="ysqQdDiscountJointBuildFeeAmount"
              width="100"
              title="折让/厂商共建费用"
            ></vxe-column>
            <vxe-column
              v-if="showThirdLevel('outboundScanReward')"
              field="ysqQdOutboundScanRewardAmount"
              width="100"
              title="出库扫码奖励"
            ></vxe-column>
            <vxe-column
              v-if="showThirdLevel('deposit')"
              field="ysqQdDepositAmount"
              width="100"
              title="保证金"
            ></vxe-column>
            <vxe-column
              v-if="showThirdLevel('salesRelatedReward')"
              field="ysqQdSalesRelatedRewardAmount"
              width="100"
              title="动销关联奖励"
            ></vxe-column>
          </vxe-colgroup>

          <vxe-column field="ysqSubtotal" width="100" title="小计"></vxe-column>
        </vxe-colgroup>
      </vxe-table>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.pageNum"
          :page-sizes="[15, 20, 25]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="动态模块展示选择"
      :visible.sync="showModuleDialog"
      width="600px"
      @close="showModuleDialog = false"
      append-to-body
    >
      <el-checkbox-group v-model="tempModuleChooseKey">
        <el-checkbox
          v-for="item in moduleOptions"
          :key="item.value"
          :label="item.value"
        >
          {{ item.label }}
        </el-checkbox>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleModuleCancel">取消</el-button>
        <el-button type="primary" @click="handleModuleConfirm">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="动态二级参数选择"
      :visible.sync="showParamDialog"
      width="600px"
      @close="showParamDialog = false"
      append-to-body
    >
      <el-checkbox-group v-model="tempParamChooseKey">
        <el-checkbox
          v-for="item in paramOptions"
          :key="item.value"
          :label="item.value"
        >
          {{ item.label }}
        </el-checkbox>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleParamCancel">取消</el-button>
        <el-button type="primary" @click="handleParamConfirm">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="动态三级参数选择"
      :visible.sync="showThirdLevelDialog"
      width="600px"
      @close="showThirdLevelDialog = false"
      append-to-body
    >
      <el-checkbox-group v-model="tempThirdLevelChooseKey">
        <el-checkbox
          v-for="item in thirdLevelOptions"
          :key="item.value"
          :label="item.value"
        >
          {{ item.label }}
        </el-checkbox>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleThirdLevelCancel">取消</el-button>
        <el-button type="primary" @click="handleThirdLevelConfirm"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import request from '@/found/utils/request';
import axios from 'axios';

export default {
  name: 'Table2',
  data() {
    const moduleOptions = [
      { label: '生产投入', value: 'group1' },
      { label: '释放投入', value: 'group2' },
      { label: '已申请投入', value: 'group3' },
    ];

    const paramOptions = [
      { label: '经销商投入', value: 'dealerInput' },
      { label: '烟酒店投入', value: 'tobaccoShopInput' },
      { label: '市场运营投入', value: 'marketOperationInput' },
      { label: '销售人员提成', value: 'salesCommission' },
      { label: '推广大使权益', value: 'promoterRights' },
      { label: '凤香荟', value: 'fengxiangHui' },
      { label: '消费者奖励', value: 'consumerReward' },
      { label: '渠道费用', value: 'channelCost' },
    ];

    const thirdLevelOptions = [
      { label: '扫码费用', value: 'scanFee' },
      { label: '季度达成', value: 'quarterAchieve' },
      { label: '稳价补贴', value: 'stablePriceSubsidy' },
      { label: '动销反向', value: 'reverseSales' },
      { label: '战略投入', value: 'strategyInput' },
      { label: '公司统筹投入', value: 'companyOverallInput' },
      { label: '市场基础投入-统筹', value: 'marketBaseOverall' },
      { label: '市场基础投入-经销商', value: 'marketBaseCustomer' },
      { label: '专项投入', value: 'specialInput' },
      { label: '厂商共建费用', value: 'jointBuildFee' },
      { label: '折让费用', value: 'discountFee' },
      { label: '出库扫码奖励', value: 'outboundScanReward' },
      { label: '保证金', value: 'deposit' },
      { label: '动销关联奖励', value: 'salesRelatedReward' },
    ];

    return {
      tableData: [],
      moduleOptions,
      paramOptions,
      thirdLevelOptions,
      moduleChooseKey: moduleOptions.map((item) => item.value),
      paramChooseKey: paramOptions.map((item) => item.value),
      thirdLevelChooseKey: thirdLevelOptions.map((item) => item.value),
      tempModuleChooseKey: moduleOptions.map((item) => item.value),
      tempParamChooseKey: paramOptions.map((item) => item.value),
      tempThirdLevelChooseKey: thirdLevelOptions.map((item) => item.value),
      tableKey: 0,
      isCalculateHeight: true,
      otherHeight: 101,
      searchOpenHeight: 0,
      tableHeight: this.setPageHeight(),
      screenHeight: window.innerHeight,
      searchForm: {
        startTime: this.getYesterday(),
        endTime: this.getToday(),
        subCompanyCode: '',
        subCompanyName: '',
        customerCode: '',
        customerName: '',
        productName: '',
        productCode: '',
      },
      showModuleDialog: false,
      showParamDialog: false,
      showThirdLevelDialog: false,
      pagination: {
        pageNum: 1,
        pageSize: 15,
        total: 0,
      },
      loading: false,
      channelOptions: [],
    };
  },
  computed: {
    startDatePickerOptions() {
      return {
        disabledDate: (time) => {
          if (this.searchForm.endTime) {
            return time.getTime() > new Date(this.searchForm.endTime).getTime();
          }
          return false;
        },
      };
    },
    endDatePickerOptions() {
      return {
        disabledDate: (time) => {
          if (this.searchForm.startTime) {
            return (
              time.getTime() < new Date(this.searchForm.startTime).getTime()
            );
          }
          return false;
        },
      };
    },
  },
  watch: {
    screenHeight(val) {
      this.setPageHeight();
    },
    tableData(val) {
      this.setPageHeight();
    },
  },
  mounted() {
    window.onresize = () => (() => {
      window.screenHeight = window.innerHeight;
      this.screenHeight = window.screenHeight;
      this.setPageHeight();
    })();
    this.getDictory();
  },
  methods: {
    async getDictory() {
      const res = await request.post('/mdm/mdmdictdata/batchDictSelect', [
        'sales_channel_terminal_dealer',
      ]);
      if (res.success) {
        this.channelOptions = res.result.sales_channel_terminal_dealer || [];
        this.getTableData();
      }
    },
    getDictLabel(dictCode) {
      const obj = this.channelOptions.find(
        (item) => item.dictCode === dictCode,
      );
      return obj?.dictValue || dictCode || '';
    },
    getToday() {
      const date = new Date();
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
        2,
        '0',
      )}-${String(date.getDate()).padStart(2, '0')}`;
    },
    getYesterday() {
      const date = new Date();
      date.setDate(date.getDate() - 1);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
        2,
        '0',
      )}-${String(date.getDate()).padStart(2, '0')}`;
    },
    async getTableData() {
      if (!this.searchForm.startTime || !this.searchForm.endTime) {
        return this.$message.error('请选择开始日期和结束日期!');
      }
      this.loading = true;
      const params = {
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
        startTime: this.searchForm.startTime,
        endTime: this.searchForm.endTime,
        subCompanyCode: this.searchForm.subCompanyCode || '',
        subCompanyName: this.searchForm.subCompanyName || '',
        customerCode: this.searchForm.customerCode || '',
        customerName: this.searchForm.customerName || '',
        productName: this.searchForm.productName || '',
        productCode: this.searchForm.productCode || '',
        companyName: this.searchForm.companyName || '',
        saleChannel: this.searchForm.saleChannel || '',
        orderCode: this.searchForm.orderCode || '',
        productLevelName: this.searchForm.productLevelName || '',
      };

      const res = await request.post(
        '/tpm/tpmMarketInputReport/findByConditions',
        params,
      );
      this.loading = false;

      if (res && res.result && res.result.data) {
        this.tableData = res.result.data.map((item) => ({
          ...item,
          saleChannelName: this.getDictLabel(item.saleChannel),
        }));
        this.pagination.total = res.result.count || 0;
        if (this.paramChooseKey.length < this.paramOptions.length) {
          this.recalculateSubtotal();
        }
        this.$nextTick(() => {
          this.setPageHeight();
        });
      }
    },
    handleSearch() {
      this.pagination.pageNum = 1;
      this.getTableData();
    },
    async handleExport() {
      this.loading = true;
      const params = {
        ...this.searchForm,
      };
      if (!params.startTime || !params.endTime) {
        this.loading = false;
        return this.$message.error('请选择开始日期和结束日期!');
      }
      try {
        const exportAxios = axios.create();
        const token = localStorage.getItem('TokenKey');
        const res = await exportAxios.post(
          '/tpm/tpmMarketInputReport/exportExcel',
          params,
          {
            responseType: 'blob',
            headers: {
              loginUserToken: token,
            },
          },
        );
        const contentType = res.headers['content-type'] || '';
        if (contentType.includes('application/json')) {
          const reader = new FileReader();
          reader.readAsText(res.data);
          reader.onload = (e) => {
            const msg = JSON.parse(e.target.result).msg || '服务端导出失败';
            this.$message.error(msg);
          };
          return;
        }

        const fileName = '市场投入报表.xlsx';
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const blobUrl = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = blobUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(blobUrl);

        this.$message.success('导出成功');
      } catch (realErr) {
        console.error('真实导出异常堆栈：', realErr);
        this.$message.error('导出失败，请查看控制台详情');
      } finally {
        this.loading = false;
      }
    },
    handleReset() {
      this.searchForm = {
        startTime: '',
        endTime: '',
        subCompanyCode: '',
        subCompanyName: '',
        customerCode: '',
        customerName: '',
        productName: '',
        productCode: '',
        companyName: '',
        saleChannel: '',
        orderCode: '',
        productLevelName: '',
      };
      this.pagination = {
        pageNum: 1,
        pageSize: 15,
        total: 0,
      };
      this.tableData = [];
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.pageNum = 1;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.pagination.pageNum = val;
      this.getTableData();
    },
    openModuleDialog() {
      this.tempModuleChooseKey = [...this.moduleChooseKey];
      this.showModuleDialog = true;
    },
    handleModuleConfirm() {
      this.moduleChooseKey = [...this.tempModuleChooseKey];
      this.showModuleDialog = false;
      this.$nextTick(() => {
        this.tableKey += 1;
      });
    },
    handleModuleCancel() {
      this.tempModuleChooseKey = [...this.moduleChooseKey];
      this.showModuleDialog = false;
    },
    openParamDialog() {
      this.tempParamChooseKey = [...this.paramChooseKey];
      this.showParamDialog = true;
    },
    handleParamConfirm() {
      this.paramChooseKey = [...this.tempParamChooseKey];
      this.showParamDialog = false;
      this.recalculateSubtotal();
      this.$nextTick(() => {
        this.tableKey += 1;
      });
    },
    handleParamCancel() {
      this.tempParamChooseKey = [...this.paramChooseKey];
      this.showParamDialog = false;
    },
    openThirdLevelDialog() {
      this.tempThirdLevelChooseKey = [...this.thirdLevelChooseKey];
      this.showThirdLevelDialog = true;
    },
    handleThirdLevelConfirm() {
      this.thirdLevelChooseKey = [...this.tempThirdLevelChooseKey];
      this.showThirdLevelDialog = false;
      this.recalculateSubtotal();
      this.$nextTick(() => {
        this.tableKey += 1;
      });
    },
    handleThirdLevelCancel() {
      this.tempThirdLevelChooseKey = [...this.thirdLevelChooseKey];
      this.showThirdLevelDialog = false;
    },
    recalculateSubtotal() {
      const scFields = [
        'scJxsScanFeeAmount',
        'scJxsQuarterAchieveAmount',
        'scJxsStablePriceSubsidyAmount',
        'scYjdScanFeeAmount',
        'scYjdQuarterAchieveAmount',
        'scYjdReverseSalesAmount',
        'scYjdStablePriceSubsidyAmount',
        'scScyyStrategyInputAmount',
        'scScyyCompanyOverallInputAmount',
        'scScyyMarketBaseOverallAmount',
        'scScyyMarketBaseCustomerAmount',
        'scScyySpecialInputAmount',
        'scSalesCommissionAmount',
        'scAmbassadorRightsAmount',
        'scFxhAmount',
        'scConsumerRewardAmount',
        'scQdJointBuildFeeAmount',
        'scQdDiscountFeeAmount',
        'scQdOutboundScanRewardAmount',
        'scQdDepositAmount',
        'scQdSalesRelatedRewardAmount',
      ];

      const sfFields = [
        'sfJxsScanFee',
        'sfJxsQuarterAchieveAmount',
        'sfJxsStablePriceSubsidyAmount',
        'sfYjdScanFeeAmount',
        'sfYjdQuarterAchieveAmount',
        'sfYjdReverseSalesAmount',
        'sfYjdStablePriceSubsidyAmount',
        'sfScyyStrategyInputAmount',
        'sfScyyCompanyOverallInputAmount',
        'sfScyyMarketBaseOverallAmount',
        'sfScyyMarketBaseCustomerAmount',
        'sfScyySpecialInputAmount',
        'sfSalesCommission',
        'sfAmbassadorRightsAmount',
        'sfFxhAmount',
        'sfConsumerRewardAmount',
        'sfQdJointBuildFeeAmount',
        'sfQdDiscountFeeAmount',
        'sfQdOutboundScanRewardAmount',
        'sfQdDepositAmount',
        'sfQdSalesRelatedRewardAmount',
      ];

      const ysqFields = [
        'ysqJxsScanFee',
        'ysqJxsQuarterAchieveAmount',
        'ysqJxsStablePriceSubsidyAmount',
        'ysqYjdScanFeeAmount',
        'ysqYjdQuarterAchieveAmount',
        'ysqYjdReverseSalesAmount',
        'ysqYjdStablePriceSubsidyAmount',
        'ysqConsumerRewardAmount',
        'ysqQdDiscountJointBuildFeeAmount',
        'ysqQdOutboundScanRewardAmount',
        'ysqQdDepositAmount',
        'ysqQdSalesRelatedRewardAmount',
      ];

      this.tableData.forEach((row, rowIndex) => {
        const updatedRow = { ...row };

        let scSubtotal = 0;
        scFields.forEach((field) => {
          if (this.isFieldVisible(field)) {
            scSubtotal += row[field] || 0;
          }
        });
        updatedRow.scSubtotal = scSubtotal;

        let sfSubtotal = 0;
        sfFields.forEach((field) => {
          if (this.isFieldVisible(field)) {
            sfSubtotal += row[field] || 0;
          }
        });
        updatedRow.sfSubtotal = sfSubtotal;

        let ysqSubtotal = 0;
        ysqFields.forEach((field) => {
          if (this.isFieldVisible(field)) {
            ysqSubtotal += row[field] || 0;
          }
        });
        updatedRow.ysqSubtotal = ysqSubtotal;

        this.tableData[rowIndex] = updatedRow;
      });
    },
    isFieldVisible(field) {
      const secondLevelVisible = this.isSecondLevelVisible(field);
      const thirdLevelVisible = this.isThirdLevelVisible(field);
      return secondLevelVisible && thirdLevelVisible;
    },
    isSecondLevelVisible(field) {
      if (field.startsWith('scJxs')) {
        return this.paramChooseKey.includes('dealerInput');
      }
      if (field.startsWith('scYjd')) {
        return this.paramChooseKey.includes('tobaccoShopInput');
      }
      if (field.startsWith('scScyy')) {
        return this.paramChooseKey.includes('marketOperationInput');
      }
      if (field.startsWith('scSalesCommission')) {
        return this.paramChooseKey.includes('salesCommission');
      }
      if (field.startsWith('scAmbassadorRights')) {
        return this.paramChooseKey.includes('promoterRights');
      }
      if (field.startsWith('scFxh')) {
        return this.paramChooseKey.includes('fengxiangHui');
      }
      if (field.startsWith('scConsumerReward')) {
        return this.paramChooseKey.includes('consumerReward');
      }
      if (field.startsWith('scQd')) {
        return this.paramChooseKey.includes('channelCost');
      }

      if (field.startsWith('sfJxs')) {
        return this.paramChooseKey.includes('dealerInput');
      }
      if (field.startsWith('sfYjd')) {
        return this.paramChooseKey.includes('tobaccoShopInput');
      }
      if (field.startsWith('sfScyy')) {
        return this.paramChooseKey.includes('marketOperationInput');
      }
      if (field.startsWith('sfSalesCommission')) {
        return this.paramChooseKey.includes('salesCommission');
      }
      if (field.startsWith('sfAmbassadorRights')) {
        return this.paramChooseKey.includes('promoterRights');
      }
      if (field.startsWith('sfFxh')) {
        return this.paramChooseKey.includes('fengxiangHui');
      }
      if (field.startsWith('sfConsumerReward')) {
        return this.paramChooseKey.includes('consumerReward');
      }
      if (field.startsWith('sfQd')) {
        return this.paramChooseKey.includes('channelCost');
      }

      if (field.startsWith('ysqJxs')) {
        return this.paramChooseKey.includes('dealerInput');
      }
      if (field.startsWith('ysqYjd')) {
        return this.paramChooseKey.includes('tobaccoShopInput');
      }
      if (field.startsWith('ysqConsumerReward')) {
        return this.paramChooseKey.includes('consumerReward');
      }
      if (field.startsWith('ysqQd')) {
        return this.paramChooseKey.includes('channelCost');
      }

      return true;
    },
    isThirdLevelVisible(field) {
      if (field.includes('ScanFee')) {
        return this.thirdLevelChooseKey.includes('scanFee');
      }
      if (field.includes('QuarterAchieve')) {
        return this.thirdLevelChooseKey.includes('quarterAchieve');
      }
      if (field.includes('StablePriceSubsidy')) {
        return this.thirdLevelChooseKey.includes('stablePriceSubsidy');
      }
      if (field.includes('ReverseSales')) {
        return this.thirdLevelChooseKey.includes('reverseSales');
      }
      if (field.includes('StrategyInput')) {
        return this.thirdLevelChooseKey.includes('strategyInput');
      }
      if (field.includes('CompanyOverallInput')) {
        return this.thirdLevelChooseKey.includes('companyOverallInput');
      }
      if (field.includes('MarketBaseOverall')) {
        return this.thirdLevelChooseKey.includes('marketBaseOverall');
      }
      if (field.includes('MarketBaseCustomer')) {
        return this.thirdLevelChooseKey.includes('marketBaseCustomer');
      }
      if (field.includes('SpecialInput')) {
        return this.thirdLevelChooseKey.includes('specialInput');
      }
      if (field.includes('JointBuildFee')) {
        return this.thirdLevelChooseKey.includes('jointBuildFee');
      }
      if (field.includes('DiscountFee')) {
        return this.thirdLevelChooseKey.includes('discountFee');
      }
      if (field.includes('OutboundScanReward')) {
        return this.thirdLevelChooseKey.includes('outboundScanReward');
      }
      if (field.includes('Deposit')) {
        return this.thirdLevelChooseKey.includes('deposit');
      }
      if (field.includes('SalesRelatedReward')) {
        return this.thirdLevelChooseKey.includes('salesRelatedReward');
      }

      return true;
    },
    setPageHeight() {
      this.$nextTick(() => {
        if (this.$refs.search) {
          const searchRect = this.$refs.search.getBoundingClientRect();
          this.searchOpenHeight = searchRect.height - 44;
        }
        if (this.$refs.page) {
          const pageRect = this.$refs.page.getBoundingClientRect();
          const pageHeight = pageRect.height;
          this.tableHeight = pageHeight - this.otherHeight - this.searchOpenHeight;
        }
      });
      return 600;
    },
    showModule(field) {
      return this.moduleChooseKey.includes(field);
    },
    showParam(field) {
      if (!this.paramChooseKey.includes(field)) {
        return false;
      }
      const paramThirdLevelMap = {
        dealerInput: ['scanFee', 'quarterAchieve', 'stablePriceSubsidy'],
        tobaccoShopInput: [
          'scanFee',
          'quarterAchieve',
          'reverseSales',
          'stablePriceSubsidy',
        ],
        marketOperationInput: [
          'strategyInput',
          'companyOverallInput',
          'marketBaseOverall',
          'marketBaseCustomer',
          'specialInput',
        ],
        salesCommission: [],
        promoterRights: [],
        fengxiangHui: [],
        consumerReward: [],
        channelCost: [
          'jointBuildFee',
          'discountFee',
          'outboundScanReward',
          'deposit',
          'salesRelatedReward',
        ],
      };
      const thirdLevelKeys = paramThirdLevelMap[field];
      if (!thirdLevelKeys || thirdLevelKeys.length === 0) {
        return true;
      }
      return thirdLevelKeys.some((key) => this.thirdLevelChooseKey.includes(key));
    },
    showThirdLevel(field) {
      return this.thirdLevelChooseKey.includes(field);
    },
    footerMethod({ columns, data }) {
      const footerData = [
        columns.map((column, _columnIndex) => {
          if (_columnIndex === 0) {
            return '合计';
          }
          const { property } = column;
          if (
            property
            && (property.endsWith('Amount')
              || property.endsWith('sfSalesCommission')
              || property.endsWith('Price')
              || property.endsWith('Quantity')
              || property.endsWith('Subtotal')
              || property.endsWith('Fee')
              || property.endsWith('Standard'))
          ) {
            let total = 0;
            this.tableData.forEach((v) => {
              total += Number(v[property]) || 0;
            });
            return Number(total.toFixed(2));
          }
          return null;
        }),
      ];
      return footerData;
    },
  },
};
</script>
<style scoped lang="less">
.page {
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}
.page-search {
  flex-shrink: 0;
  margin-bottom: 16px;
}
.search-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  width: 100%;
}
.search-row .el-date-picker,
.search-row .el-select,
.search-row .el-input {
  width: 232px;
  margin-right: 10px;
}
.search-row .el-button {
  margin-left: 10px;
}
.select-row {
  display: flex;
  align-items: center;
}
.select-row .el-button {
  margin-left: 5px;
}
.page-table {
  flex: 1;
  min-height: 0;
  overflow-x: auto;
  overflow-y: hidden;
  margin-bottom: 16px;
}
.pagination {
  flex-shrink: 0;
  text-align: right;
  margin-bottom: 16px;
}
.table-column-box {
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-shrink: 0;
  flex-wrap: wrap;
}
.el-checkbox-group {
  margin-right: 10px;
  width: 90%;
  padding-bottom: 20px;
}
.el-checkbox {
  margin-right: 15px;
  margin-bottom: 8px;
}
.vxe-table {
  width: 100%;
}

/deep/.table-header {
  background: #e8e8e8;
}
</style>
